import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'semantic-ui-react'
import styled from 'styled-components'

import { QuestionBuilderConsumer } from 'organisms/QuestionBuilderCard'
import { QuestionTypeField } from 'organisms/QuestionInput'
import { TooltipLabel } from 'components/TooltipLabel'
import { Value } from 'react-powerplug'
import { getQuestionTemplate } from 'organisms/SurveySettingsV2/utils'
import PrimaryQuestionMetricInput from './PrimaryQuestionMetricInput'
import PrimaryQuestionTextInput from './PrimaryQuestionTextInput'
import baseConstant from 'config/constants'
import useFeatureToggle from 'hooks/useFeatureToggle'

export const InputWrapper = styled(Input)`
  &.ui.input.labeled input[disabled] {
    background: rgba(244, 244, 244, 0.8);
    color: #373f46;
    opacity: 1;
  }
`

const hackLabeledDropdownStyle = {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
}

const primaryMetricDropdownOptions = [
  { key: 'CSAT', value: 'CSAT', text: baseConstant.questionMetricTitle.CSAT },
  { key: 'NPS', value: 'NPS', text: baseConstant.questionMetricTitle.NPS },
  { key: 'CES', value: 'CES', text: baseConstant.questionMetricTitle.CES },
  { key: 'star', value: '5-STAR', text: baseConstant.questionMetricTitle.star },
]

export const PrimaryQuestionInput = ({ canChangePrimaryMetric }) => {
  const { enableMetricReorder } = useFeatureToggle()

  return (
    <QuestionBuilderConsumer>
      {({ handleFieldChange, question, questionIndex, arrayHelpers }) => {
        return (
          <Value initial={question.metric}>
            {({ value: metric, set }) => {
              const handleMetricChange = (_, { value }) => {
                set(value)

                arrayHelpers.replace(questionIndex, getQuestionTemplate(value))
              }

              return (
                <React.Fragment>
                  <Form.Field>
                    <TooltipLabel
                      label="Metric"
                      descriptionTitle="Metric"
                      descriptionContent="Customer satisfaction metrics such as CSAT or NPS categorize this question's ratings. The metric powers your survey's main stats, leaderboards, benchmarks, and notifications."
                      learnMoreLink="https://help.simplesat.io/surveys/survey-metrics-explained"
                    />
                    <PrimaryQuestionMetricInput
                      canChangePrimaryMetric={canChangePrimaryMetric}
                      matchFieldStyle={enableMetricReorder}
                      metric={metric}
                      handleMetricChange={handleMetricChange}
                      hackLabeledDropdownStyle={hackLabeledDropdownStyle}
                      primaryMetricDropdownOptions={primaryMetricDropdownOptions}
                    />
                  </Form.Field>
                  {enableMetricReorder && <QuestionTypeField type={question.type} />}
                  <Form.Field>
                    <label>Question</label>
                    <Input
                      className="large"
                      required
                      data-test="firstQuestion"
                      data-testid="primary-question-title"
                      value={question.text}
                      onChange={handleFieldChange('text')}
                    />
                  </Form.Field>
                  <PrimaryQuestionTextInput metric={metric} />
                </React.Fragment>
              )
            }}
          </Value>
        )
      }}
    </QuestionBuilderConsumer>
  )
}

PrimaryQuestionInput.propTypes = {
  canChangePrimaryMetric: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/PrimaryQuestionInput/index.js